/**
 * STATIC placeholder data, shaped by docs/design/throughline-contract.md's
 * "Data bindings (91)" list and "Backend mapping" section. This is scaffold-
 * only content — wiring each screen to its real backend source (dna_profiles,
 * presence GET, the bucketed inbox, etc.) is B-2..B-6, explicitly NOT this
 * brief. Every value here exists ONLY so B-1's screens render something that
 * matches the mockup's shape; nothing here is a claim about a real user.
 */

export interface PlaceholderJob {
  id: string;
  title: string;
  company: string;
  location: string;
  match: number;
  tailored: boolean;
  color: string;
  mono: string;
}

export const placeholderJobs: PlaceholderJob[] = [
  {
    id: 'j1',
    title: 'Solutions Architect',
    company: 'Northwind',
    location: 'Remote',
    match: 64,
    tailored: false,
    color: '#4F6D7A',
    mono: 'N',
  },
  {
    id: 'j2',
    title: 'Platform Lead',
    company: 'Bright Labs',
    location: 'NYC · Hybrid',
    match: 58,
    tailored: false,
    color: '#B5654A',
    mono: 'B',
  },
  {
    id: 'j3',
    title: 'Operations Lead',
    company: 'Mapleworks',
    location: 'Remote',
    match: 71,
    tailored: false,
    color: '#6E7E63',
    mono: 'M',
  },
];

export const placeholderHome = {
  greetingName: 'there',
  initial: 'T',
  storyPct: 62,
  threadCount: 2,
  threadItems: ['Cross-functional collaboration', 'Mentorship & growth'],
  gfScore: 68,
  rolesRead: 12,
};

export const placeholderRefine = {
  threads: ['Cross-functional collaboration', 'Mentorship & growth'],
  firstMessage:
    "Hi — I just finished reading your resume, and there's real substance here. I'd love to hear about a moment at work you're proud of. Even a small one — what comes to mind?",
  voiceHint: 'Speak naturally — pauses are okay.',
};

export const placeholderProfiles = {
  gfScore: 68,
  gfNote: "Apply Meira's headline below and watch this climb.",
  liPct: 72,
  liOld: 'Operations Manager at Acme Co.',
  liNew: 'Operations leader who turns chaos into systems — onboarding, process & teams that scale',
  recruiterOn: true,
  suggestedTitles: ['Solutions Architect', 'Platform Lead', 'Operations Lead'],
};
